import React, { ReactNode } from "react";
import "./LearningPage.css";

type LearningPageStudentProps = {
  readonly children: ReactNode;
};

export default function LearningPageStudent({
  children,
}: LearningPageStudentProps) {
  return <div className="learning-student">{children}</div>;
}
